import { render, staticRenderFns } from "./ValueAndChange.vue?vue&type=template&id=62c57416&scoped=true&"
import script from "./ValueAndChange.vue?vue&type=script&lang=js&"
export * from "./ValueAndChange.vue?vue&type=script&lang=js&"
import style0 from "./ValueAndChange.vue?vue&type=style&index=0&id=62c57416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c57416",
  null
  
)

export default component.exports